import { SelectDestinationTypeCacheState } from './interface';

export const SELECT_DESTINATION_TYPE_CACHE_DEFAULT_STATE: SelectDestinationTypeCacheState = {};
